import {FormattedMessage} from 'react-intl';

import {Action, Button, Icon, tokens, Tooltip, view} from '@sail/ui';
import {refresh} from '@sail/icons/react/Icon';

import {
  HeaderBadge,
  useConversation,
} from '@stripe-internal/conversations-assistant';
import {noTranslateMessages} from '@stripe-internal/conversations-ui';

const messages = noTranslateMessages({
  end: {
    id: 'mobile_conversations_assistant.dev_header.end',
    description: 'Label for the end botton',
    defaultMessage: 'End',
  },
  restart: {
    id: 'mobile_conversations_assistant.dev_header.restart',
    description: 'Label for the restart botton',
    defaultMessage: 'Restart',
  },
});

export function MobileDevHeader() {
  const {endConversation, restartConversation} = useConversation();

  const urlSearchParams = new URLSearchParams(window.location.search);
  const debugMode = urlSearchParams.get('__debug') || 'off';

  if (debugMode === 'off') {
    return null;
  }

  return (
    <view.div
      data-testid="mobile-dev-header"
      css={{
        stack: 'x',
        padding: 'small',
        borderBottom: '1px solid',
        borderBottomColor: 'border',
        alignY: 'center',
        distribute: 'space-between',
        zIndex: 2,
        background: `color-mix(in rgb, ${tokens.color.background.surface} 25%, transparent 75%)`,
        backdropFilter: 'blur(4px)',
      }}
    >
      <HeaderBadge />

      <view.div css={{stack: 'x', gap: 'small', alignY: 'center'}}>
        <Tooltip
          type="label"
          delay={600}
          trigger={
            <Action
              data-testid="mobile-dev-header-restart-btn"
              onPress={() => restartConversation()}
              css={{
                display: 'inline-flex',
                borderRadius: 'rounded',
                padding: 'small',
                ':hover': {
                  backgroundColor: 'offset',
                },
              }}
            >
              <Icon icon={refresh} size="xsmall" />
            </Action>
          }
        >
          <FormattedMessage {...messages.restart} />
        </Tooltip>
        <Button
          size="small"
          onPress={() => endConversation()}
          data-testid="mobile-dev-header-end-btn"
        >
          <FormattedMessage {...messages.end} />
        </Button>
      </view.div>
    </view.div>
  );
}
